// Where to send someone back to after they sign out to accept an invite that
// was addressed to a different account.
//
// The logout can only return to the bare origin (the one URL Auth0 has on its
// allow-list), so the invite link is kept here across the round trip.
// sessionStorage, not localStorage: it must not outlive the tab.
const KEY = 'sc:invite-return-to'

export function rememberInviteReturn(path: string): void {
  try {
    sessionStorage.setItem(KEY, path)
  } catch {
    // Storage unavailable: they land on the login page and reopen the email.
  }
}

/** The stored invite link, only if it really is one. */
export function inviteReturn(): string | null {
  try {
    const path = sessionStorage.getItem(KEY)
    return path?.startsWith('/accept-invite?') ? path : null
  } catch {
    return null
  }
}

export function forgetInviteReturn(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing stored, nothing to clear.
  }
}
